"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const bottom_tabs_1 = require("@react-navigation/bottom-tabs");
const react_native_1 = require("react-native");
const colors_1 = require("../common/colors");
const DiscoverRightHeader_1 = __importDefault(require("../component/DiscoverRightHeader"));
const AppText_1 = require("../component/AppText");
const DiscoverProfile_1 = require("../screen/Discover/DiscoverProfile");
const Documents_1 = __importDefault(require("../screen/Discover/Documents"));
const Library_1 = __importDefault(require("../screen/Discover/Library"));
const AllCharacterList_1 = __importDefault(require("../screen/AllCharacterList"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const native_base_1 = require("native-base");
const react_1 = require("react");
const react_native_device_info_1 = __importDefault(require("react-native-device-info"));
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const theme_1 = require("../helper/theme");
const HeaderSearchButtons_1 = require("./HeaderSearchButtons");
const useDevice_1 = require("../hooks/useDevice");
const rootNavigation_1 = require("../navigation/rootNavigation");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const deviceModel = react_native_device_info_1.default.getModel();
const Tab = (0, bottom_tabs_1.createBottomTabNavigator)();
function MyTabs() {
    const [nameInitials, setNameInitials] = (0, react_1.useState)({});
    const [userName, setUserName] = (0, react_1.useState)("");
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    /**
     *
     */
    const refreshUser = async () => {
        const displayNameStored = await async_storage_1.default.getItem("displayName");
        if (displayNameStored) {
            const [first, last] = displayNameStored.split(" ");
            setNameInitials({ first, last });
            setUserName(displayNameStored || "");
        }
        else if (fbUser && fbUser.displayName) {
            const [first, last] = fbUser.displayName.split(" ");
            setNameInitials({ first, last });
            setUserName(fbUser?.displayName || "");
        }
        else if (fbUser?.providerData?.[0]?.displayName) {
            const [first, last] = fbUser?.providerData?.[0]?.displayName.split(" ");
            setNameInitials({ first, last });
            setUserName(fbUser?.providerData?.[0]?.displayName || "");
        }
    };
    (0, react_1.useEffect)(() => {
        if (!userName && fbUser?.displayName) {
            refreshUser();
        }
    }, [fbUser?.uid, userName]);
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const { isTabOrDesktopDevice, isWebDevice, isMobileScreen } = (0, useDevice_1.useDevice)();
    const tabBottomPadding = (0, react_1.useMemo)(() => {
        if (deviceModel.includes("iPhone SE")) {
            console.log("iPhone SE insets:", insets);
            return 10;
        }
        console.log("iPhone insets:", insets);
        return 20;
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Tab.Navigator, { initialRouteName: "Documents", screenOptions: ({ route }) => ({
            tabBarActiveTintColor: colors_1.Colors.white,
            tabBarInactiveTintColor: colors_1.Colors.PRIMARY_100,
            tabBarAllowFontScaling: false,
            tabBarStyle: {
                backgroundColor: colors_1.Colors.TAB_BG,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                paddingBottom: tabBottomPadding,
                // position: "absolute",
                // justifyContent: "flex-start",
                margin: 0,
                borderTopWidth: 0,
                minHeight: 70,
                ...(isTabOrDesktopDevice && {
                    display: "none",
                }),
            },
            tabBarIconStyle: {
                marginBottom: 0,
                padding: 0,
                margin: 0,
            },
            headerShadowVisible: false,
            tabBarLabelStyle: {
                fontSize: (0, theme_1.scaleFont)(11),
                // fontWeight: "bold",
            },
            headerStatusBarHeight: (isWebDevice && !isMobileScreen) ? 32 : undefined,
            headerStyle: {
                height: (isWebDevice && !isMobileScreen) ? 80 : undefined,
                zIndex: -1,
                // borderColor: "#f00",
                // borderWidth: 1,
            },
            headerLeftContainerStyle: {
                paddingLeft: (isWebDevice && !isMobileScreen) ? 32 : 12,
            },
            headerRightContainerStyle: {
                paddingRight: (isWebDevice && !isMobileScreen) ? 32 : 12,
            },
            header: ({ options: { headerLeft, headerRight, headerStyle, headerLeftContainerStyle, headerRightContainerStyle, headerTintColor, headerPressColor, headerPressOpacity, title, }, route: { name, } }) => {
                const HeaderLeft = headerLeft && headerLeft({
                    tintColor: headerTintColor,
                    pressColor: headerPressColor,
                    pressOpacity: headerPressOpacity,
                });
                const HeaderRight = headerRight && headerRight({
                    tintColor: headerTintColor,
                    pressColor: headerPressColor,
                    pressOpacity: headerPressOpacity,
                });
                return ((0, jsx_runtime_1.jsxs)(react_native_1.Animated.View, { style: [{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }, headerStyle], children: [(0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: headerLeftContainerStyle, children: HeaderLeft ?? ((0, jsx_runtime_1.jsx)(AppText_1.DiscoverScreenHeading, { color: colors_1.Colors.white, alignSelf: "flex-start", backgroundColor: "#f00", children: title || name })) }), (0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: headerRightContainerStyle, children: HeaderRight })] }));
            },
            headerRight: () => isWebDevice ? ((0, jsx_runtime_1.jsx)(DiscoverRightHeader_1.default, { search: route.name.toLowerCase() })) : ((0, jsx_runtime_1.jsx)(HeaderSearchButtons_1.HeaderSearchButton, { activeCategory: route.name.toLowerCase() })),
        }), children: [(0, jsx_runtime_1.jsx)(Tab.Screen, { name: "Documents", component: Documents_1.default, options: {
                    headerTitle: "",
                    headerTintColor: "#fff",
                    tabBarLabel: "Documents",
                    tabBarIcon: ({ color, size }) => ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBookOpenCover, size: size, color: color })),
                } }), (0, jsx_runtime_1.jsx)(Tab.Screen, { name: "Chats", component: AllCharacterList_1.default, options: {
                    headerTitle: "",
                    headerShown: !isTabOrDesktopDevice,
                    // headerRight: () => <HeaderSearchButton activeCategory="chats" />,
                    headerTintColor: "#fff",
                    tabBarLabel: "Chats",
                    tabBarIcon: ({ color, size }) => ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faComments, size: size, color: color })),
                } }), (0, jsx_runtime_1.jsx)(Tab.Screen, { name: "Library", component: Library_1.default, options: {
                    headerTitle: "",
                    headerTintColor: "#fff",
                    tabBarLabel: "Library",
                    tabBarIcon: ({ color, size }) => ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBooks, size: size, color: color })),
                } }), (0, jsx_runtime_1.jsx)(Tab.Screen, { name: "Account", component: DiscoverProfile_1.DiscoverProfile, options: {
                    headerTitle: "",
                    headerLeft: () => ((0, jsx_runtime_1.jsx)(AppText_1.DiscoverScreenHeading, { color: colors_1.Colors.white, alignSelf: "flex-start", backgroundColor: "#f00", children: "Account" })),
                    headerRight: () => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: fbUser?.uid && userName ? ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: async () => {
                                (0, rootNavigation_1.navigate)("AccountSettings");
                            }, children: (0, jsx_runtime_1.jsx)(native_base_1.Avatar, { bg: colors_1.Colors.PRIMARY_100, size: "sm", marginRight: 1, children: nameInitials?.first
                                    ? `${nameInitials?.first?.charAt(0)?.toUpperCase() || ""}${nameInitials?.last?.charAt(0)?.toUpperCase() || ""}`
                                    : userName?.charAt(0) }) })) : ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faUser, size: 28, style: {
                                marginRight: 1,
                            }, color: colors_1.Colors.PRIMARY_100 })) })),
                    headerTintColor: "#fff",
                    // header: () => <></>,
                    tabBarLabel: "Account",
                    tabBarIcon: ({ focused, color, size }) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: fbUser?.uid && userName ? ((0, jsx_runtime_1.jsx)(native_base_1.Avatar, { alignSelf: "center", bg: color, size: size, color: color, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: focused ? colors_1.Colors.DARK_700 : colors_1.Colors.WHITE_SECONDARY, children: nameInitials?.first
                                    ? `${nameInitials?.first?.charAt(0)?.toUpperCase() || ""}${nameInitials?.last?.charAt(0)?.toUpperCase() || ""}`
                                    : userName?.charAt(0) }) })) : ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faUser, size: size, color: color })) })),
                } })] }));
}
exports.default = MyTabs;
